<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <card>
                        <template slot="header">
                            <div class="loader" v-if="loading"></div>
                            <h4 class="card-title">Логи</h4>
                            <p class="card-category"></p>

                            <div class="row mt10">
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label class="control-label">Тип</label>
                                        <select v-model="type" id="type-filter"
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option value="" selected>All</option>
                                            <option v-for="t in types" v-bind:value="t">{{ t }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <fg-input type="text"
                                              label="Поиск по user id"
                                              v-model="userId"
                                              placeholder="">
                                    </fg-input>
                                </div>
                                <div class="col-md-2">
                                    <fg-input type="text"
                                              label="Поиск по ошибке"
                                              v-model="summary"
                                              placeholder="11821 / Code: 3">
                                    </fg-input>
                                </div>
                                <div class="col-md-2">
                                    <button type="submit" class="btn btn-info btn-fill"
                                            @click.prevent="filter">
                                        Фильтровать
                                    </button>
                                </div>
                                <div class="col-md-4"></div>
                            </div>

                        </template>
                        <div class="table-responsive">
                            <table class="table" v-bind:class="{ 'loading-state': loading }">
                                <thead>
                                <slot name="columns">
                                    <th v-for="column in columns">
                                        <span v-if="column === 'user_id'">user ID</span>
                                        <span v-else-if="column === 'locale'">locale</span>
                                        <span v-else-if="column === 'version'">version</span>
                                        <span v-else-if="column === 'file'">file</span>
                                        <span v-else-if="column === 'created_at'">date</span>
                                        <span v-else>{{column}}</span>
                                    </th>
                                </slot>
                                </thead>
                                <tbody>
                                <tr v-for="item in data">
                                    <slot :row="item">
                                        <td v-for="column in columns">
                                            <span v-if="column === 'created_at'">
                                                {{ item[column] | toEasyDate }}
                                            </span>
                                            <span v-else-if="column === 'file'">
                                                <a class="text-primary" target="_blank" :href="item[column]">{{ item[column] }}</a>
                                              </span>
                                            <span v-else>{{ item[column] }}</span>
                                        </td>
                                    </slot>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div :class="{ 'disabled' : data.length < limit }" class="pagination-button btn btn-warning btn-fill float-right"
                             @click.prevent="next">
                            След.
                        </div>
                        <div :class="{ 'disabled' : offset < limit }" class="pagination-button btn btn-warning btn-fill float-right"
                             @click.prevent="prev">
                            Пред.
                        </div>
                    </card>

                </div>

            </div>
        </div>
    </div>
</template>
<script>
const axios = require('axios')
const moment = require('moment')
import LTable from 'src/components/UIComponents/Table.vue'
import Card from 'src/components/UIComponents/Cards/Card.vue'

export default {
    components: {
        LTable,
        Card
    },
    created: function () {
        this.init();
    },
    data() {
        return {
            columns: ['id', 'user_id', 'type', 'locale', 'version', 'file', 'created_at'],
            data: [],
            type: "",
            userId: null,
            summary: "",
            types: localStorage.getItem('l_types') ? JSON.parse(localStorage.getItem('l_types')) : [],
            loading: false,
            limit: 20,
            offset: parseInt(localStorage.getItem('logs_active_offset')) || 0,
        }
    },
    filters: {
        toEasyDate (value) {
            if (value) {
                return moment(String(value)).format('DD.MM.YYYY HH:mm')
            } else {
                return '';
            }
        },
    },
    methods: {
        init: function () {
            this.get()
        },
        filter: function () {
            localStorage.setItem('logs_active_offset', "0");
            this.offset = 0;
            this.get();
        },
        prev: function () {
            if (this.offset >= this.limit) {
                this.offset -= this.limit;
                this.get();
                localStorage.setItem('logs_active_offset', parseInt(this.offset));
            }
        },
        next: function () {
            if (this.data.length === this.limit) {
                this.offset += this.limit;
                this.get();
                localStorage.setItem('logs_active_offset', parseInt(this.offset));
            }
        },
        openLink: function (link) {
            console.log(link);
        },
        get: function () {
            let self = this;

            let token = localStorage.getItem('token');

            this.loading = true;

            axios.get(
                `${this.$hostname}/admin/services/logs/`,
                {
                    'params': {
                        type: this.type,
                        limit: this.limit,
                        offset: this.offset,
                        user_id: this.userId,
                        summary: this.summary,
                    },
                    'headers': {
                        'Authorization': 'Bearer ' + token
                    }
                })
                .then(function (response) {
                    self.data = response.data.logs;
                    if (self.type === "") {
                        self.types = response.data.types;
                        localStorage.setItem('l_types', JSON.stringify(self.types));
                    }
                    self.loading = false;
                })
                .catch(function (error) {
                    self.loading = false;
                    console.log(error)
                })
        },
    },
    beforeRouteLeave (to, from , next) {
        next();
    },
}
</script>
<style scoped>
.pagination-button {
    height: 30px;
    padding: 1px 16px;
    margin-left: 20px;
    color: #fff !important;
}
.pagination-button.disabled {
    opacity: 0.6;
    cursor: not-allowed;
}
.mt10 {
    margin-top: 10px;
}
.mt10 {
    margin-top: 10px;
}

.btn-fill {
    margin-top: 25px;
}
.text-primary {
    cursor: pointer;
}
th {
    padding: 12px 8px;
}
.loader {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url('/static/img/oval.svg');
    background-size: 50px;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10000000;
    opacity: 0.7;
    filter: alpha(opacity=40);
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Logs.vue